import {createContext, useContext} from 'react';

import {SettingsRouteFinder} from '../../settings/settingsRoutes';
import {SettingsLegacyRewriteRouteFinder} from './legacyRewriteRoutes';

/*
 * Props.
 */

export interface LegacyFrameContextProps {
  findNewLegacyRoute: SettingsRouteFinder;
  findRewriteLegacyRoute: SettingsLegacyRewriteRouteFinder;
}

/*
 * Context.
 */

export const LegacyFrameContext = createContext<LegacyFrameContextProps>({
  findNewLegacyRoute: () => undefined,
  findRewriteLegacyRoute: () => undefined,
});

/*
 * Hook.
 */

export function useLegacyFrameContext() {
  return useContext(LegacyFrameContext);
}
